module.exports = __webpack_public_path__ + "i18n/languages.b1c2153.json";